import { type FetchExternalAddressesParamsNetworks, type WalletExternalAddress } from '@capsicum/common';
import { useQuery } from '@tanstack/react-query';

import { fetchExternalAddresses } from '../api';

/**
 * @param network - 'ethereum' | 'cc1' | 'polygon' | 'cc2
 * @returns Array<WalletExternalAddress>
 */
export const useWalletExternalAddressesQuery = <TData = Array<WalletExternalAddress> | undefined>(
	network: FetchExternalAddressesParamsNetworks,
	select: (data: Array<WalletExternalAddress> | undefined) => TData
) =>
	useQuery({
		queryFn: () =>
			fetchExternalAddresses({
				'networks[]': [network],
				'statuses[]': ['enabled']
			}),
		queryKey: ['recipients', network],
		select
	});
